import Vue from 'vue'
import Vuex from 'vuex'

import { overrideQuestionModel } from '../model/override-question-model.js'
import { completionMap } from '../model/completion-map.js'
import testSets from '../model/test-sets.js'
import { storeUtils } from './store-utils.js'

Vue.use(Vuex)

////////////////////////////////////////////
// Versioning
////////////////////////////////////////////

let currentVersion = function() {
  return "1.1.2"
}

export default new Vuex.Store({
  state: {
    // Was this page created from another site?
    caller: null,
    // Location, if known, as {lat: Number, lng: Number}
    location: null,
    // Identifiers
    hrcid: null,
    version: currentVersion(),
    source: null,
    // User input into Survey
    enums: overrideQuestionModel.getEnums(),
    // Data passed in within URI
    queryData: null,
    queryDataCount: 0
  },
  getters: {
    getEnumWhich: (state) => (id) => {
      return state.enums.find(e => e.id == id).which
    },
    getEnumHasValue: (state) => (id) => {
      return state.enums.find(e => e.id == id).which >= 0
    },
    getEnumWasSet: (state) => (id) => {
      return state.enums.find(e => e.id == id).userSet
    },
    getQuestionAllUserSet: (state) => (id) => {
      let ens = storeUtils.getAllEnumsFor(state.enums, id)
      return ens.filter(e => !e.userSet).length == 0
    },
    getQuestionHasAllValues: (state) => (id) => {
      let ens = storeUtils.getAllEnumsFor(state.enums, id)
      return ens.filter(e => (e.which < 0)).length == 0
    },
    getChildEnums: (state) => (id) => {
      return state.enums.filter(e => e.parentId == id).sort(e => e.index)
    },
    getEnumsFor: (state) => (id) => {
      return storeUtils.getAllEnumsFor(state.enums, id)
    },
    getAnswers: (state) => (includePrefix) => {
      return storeUtils.exportValuePairs(state.enums, includePrefix)
    },
    getVersion: (state) => {
      return state.version
    },
    getId: (state) => {
      return { hrcid : state.hrcid, source: state.source, time: new Date() }
    },
    getLocation: (state) => {
      return state.location
    },
    getNcarObject: (state) => {
      return {
        version: state.version,
        id: { hrcid : state.hrcid, source: state.source, time: new Date() },
        questions: storeUtils.exportValuePairs(state.enums, true),
        location: state.location
      }     
    },
    getCompletionData: (state) => {
      return storeUtils.extractCompletionData(state)
    }
  },
  mutations: {
    setEnum(state, p) {
      let en = state.enums.find(e => e.id == p.id)
      en.which = p.index
      if (p.userSet) {
        en.userSet = true
      }
      completionMap.clearQuestionMap();
    },
    clearEnum(state, p) {
      let en = state.enums.find(e => e.id == p.id)
      en.which = -1
      en.userSet = false
    },
    acceptQuestion(state, p) {
      storeUtils.getAllEnumsFor(state.enums, p.id).forEach(e => e.userSet = true)
      completionMap.clearQuestionMap();
    },
    applyQueryData(state, p) {
      // Payload is:
      //  queryData : any, as returned by query-parser.js!parseQuery()
      //  override  : bool (optional, default=false): unless true 
      //              the mutation will be ignored for second and subsequent calls
      if (!p.override && (state.queryDataCount > 0)) {
        return
      }
      state.queryDataCount++
      state.queryData = p.queryData
      state.caller = p.queryData.caller
      state.returnUrl = p.queryData.returnUrl,
      state.location = p.queryData.location
      state.hrcid = p.queryData.hrcid
      state.source = p.queryData.source
      if (p.queryData.previous) {
        let valuePairSet = Object.entries(p.queryData.previous.questions)
        // console.log('About to apply:')
        // console.log(valuePairSet)
        storeUtils.applyValuePairs(state.enums, valuePairSet, false)
      }
    },
    // Test methods
    applySavedValues(state, p) {
      if (p.valuePairSet != null) {
        storeUtils.applyValuePairs(state.enums, p.valuePairSet, p.userSet)
      }
      else if (p.whichSet != null) {
        storeUtils.applyValuePairs(state.enums, testSets.getValuePairSet(p.whichSet), p.userSet)
      }
    },
    acceptAllQuestions(state) {
      // payload is ignored
      state.enums.forEach(e => e.userSet = true);
      completionMap.clearQuestionMap();
    }
  },
  actions: {
  },
  modules: {
  }
})
